const KEY_ALL = 'all';

export const shouldShowAccordion = (
  categories: string[] = [],
  valueFromQueryParam: string | null = null,
) => {
  // Show all accordions if the query param is not present
  // If the accordion doesn't have a Category then it should be visibile across all selected query params
  if (
    !valueFromQueryParam ||
    valueFromQueryParam === KEY_ALL ||
    categories?.length === 0
  ) {
    return true;
  }

  return categories?.some((category) => category === valueFromQueryParam);
};
